import React, { useEffect } from 'react';
import s from './VersionControlPage.module.css';
import Header from '../start-page/Header';
import Banner from './Banner';
import CtaSection from '../start-page/CtaSection';
import Footer from '../start-page/Footer';
import HeroSection from './HeroSection';
import DescribeSection from './DescribeSection';
import TextSection from './TextSection';
const VersionControlPage: React.FC = () => {
    useEffect(() => {
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
    }, []);
    return (
        <div className={s.container}>
            <Header />
            <Banner />
            <HeroSection />
            <DescribeSection />
            <TextSection />
            <CtaSection />
            <Footer />
        </div>
    );
};

export default VersionControlPage;
